// Shared BS/AD date input (moved from src/accounting/shared.js in Stage 2E-2, unchanged; Accounts re-exports it).
// Used by Accounts and Sales. `cal` comes from makeCalendar() in src/lib/bs.js.
import { useState, useEffect } from "react";
import { Input, Select } from "./components";
import { T, text } from "./tokens";
import { BS_MONTHS, fmtAd, fmtBs } from "../../lib/bs";

// Date input in BS (default) or AD. Value is always an AD "YYYY-MM-DD" string.
export function DualDateInput({ value, onChange, cal, display = "BS" }) {
    const [mode, setMode] = useState(display === "AD" ? "AD" : "BS");
    const bs = value ? cal.adToBs(value) : null;
    const years = cal.years;
    const [y, setY] = useState(bs?.y || years[years.length - 1] || 2082);
    const [m, setM] = useState(bs?.m || 1);
    const [d, setD] = useState(bs?.d || 1);
    useEffect(() => { if (bs) { setY(bs.y); setM(bs.m); setD(bs.d); } }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
    const month = cal.month(y, m);
    const pickBs = (ny, nm, nd) => {
        setY(ny); setM(nm); setD(nd);
        const iso = cal.bsToAd(ny, nm, nd);
        onChange(iso || "");
    };
    const toggle = (
        <div style={{ display: "flex", gap: 4, marginBottom: 6 }}>
            {["BS", "AD"].map(k => (
                <button key={k} type="button" onClick={() => setMode(k)} aria-pressed={mode === k}
                    style={{ border: `1px solid ${mode === k ? T.primary : T.border}`, background: mode === k ? T.primary + "22" : "transparent", color: mode === k ? T.textStrong : T.textMuted,
                        borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: T.font }}>{k === "BS" ? "Nepali (BS)" : "English (AD)"}</button>
            ))}
        </div>
    );
    return (
        <div>
            {toggle}
            {mode === "BS" ? (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr 0.8fr", gap: 8 }}>
                    <Select aria-label="BS year" value={y} onChange={e => pickBs(Number(e.target.value), m, d)}>
                        {years.map(v => <option key={v} value={v}>{v}</option>)}
                    </Select>
                    <Select aria-label="BS month" value={m} onChange={e => pickBs(y, Number(e.target.value), d)}>
                        {BS_MONTHS.map((name, i) => <option key={name} value={i + 1} disabled={!cal.month(y, i + 1)}>{name}{cal.month(y, i + 1) ? "" : " (not in calendar)"}</option>)}
                    </Select>
                    <Select aria-label="BS day" value={d} onChange={e => pickBs(y, m, Number(e.target.value))}>
                        {Array.from({ length: month?.days || 32 }, (_, i) => i + 1).map(v => <option key={v} value={v}>{v}</option>)}
                    </Select>
                </div>
            ) : (
                <Input type="date" value={value || ""} onChange={e => onChange(e.target.value)} />
            )}
            <div style={{ ...text.caption, marginTop: 6 }}>
                {value ? (mode === "BS" ? `= ${fmtAd(value)} (AD)` : (cal.adToBs(value) ? `= ${fmtBs(cal.adToBs(value))} (BS)` : "This date is outside the loaded Nepali calendar."))
                    : (mode === "BS" && !month ? "That month is not in the calendar yet." : "Choose a date.")}
            </div>
        </div>
    );
}
